import { Button, Icon, Text } from '@pairy/pds-react';

import * as Styled from './index.styles';

interface Props {
  openForm: () => void;
  translateKoToEn: (item: string) => string;
}

/** 스크롤 모드에서 CTA 폼 게이트 페이지 위에 표시되는 안내 오버레이 */
const GateStopper = ({ openForm, translateKoToEn }: Props) => {
  return (
    <Styled.Overlay
      direction="column"
      gap={16}
      alignItems="center"
      justifyContent="center"
    >
      <Icon icon="ph:lock-simple" size={32} color="white" />
      <Text variant="lg-semibold" color="white" textAlign="center">
        {translateKoToEn('form-gate-continue')}
      </Text>
      <Button
        variant="skyblue_400_fill"
        radius={9999}
        paddingX={24}
        paddingY={12}
        onClick={(e) => {
          e.stopPropagation();
          openForm();
        }}
      >
        <Text variant="lg-medium" color="white">
          {translateKoToEn('form-gate-open')}
        </Text>
      </Button>
    </Styled.Overlay>
  );
};

export default GateStopper;
